export default __webpack_public_path__ + "static/logo_white-a604cc20959753c90676c4594f3baff5.png";